import { VehicleGalleryContextProvider } from '@/contexts/vehicle-gallery-provider';
import Gallery from './components/gallery';

type VehicleGalleryProps = {
  vehicleListingID: string;
};

// Dev note: gallery components and its actions have been broken down into components in order
// to reduce amount of code that would otherwise sit in one giant component.
const VehicleGallery = ({ vehicleListingID }: VehicleGalleryProps) => {
  return (
    <VehicleGalleryContextProvider vehicleListingID={vehicleListingID}>
      <Gallery />
    </VehicleGalleryContextProvider>
  );
};

export default VehicleGallery;
